export const theme = {
    fontFamily: 'inter',
    colorPrimary: '#333',
    colorPrimaryBg: '#e5e5e5',
    colorSuccess: '#2b8',
    colorInfo: '#333',
    colorInfoBg: 'rgb(224, 255, 251)',
    colorInfoBgHover: 'rgb(190, 250, 250)',
    colorInfoBorder: '#14c2cc'
}
